import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const groupItemTemplatesApi = {
    getGroupItemTemplates: (groupId: number): Observable<Dtos.GetGroupItemTemplatesResponse> => {
        //Create the request.
        let request: Dtos.GetGroupItemTemplates = new Dtos.GetGroupItemTemplates();

        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.GetGroupItemTemplatesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getGroupItemTemplateById: (id: number): Observable<Dtos.GetGroupItemTemplateByIdResponse> => {
        //Create the request.
        let request: Dtos.GetGroupItemTemplateById = new Dtos.GetGroupItemTemplateById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetGroupItemTemplateByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setGroupItemTemplate: (groupItemTemplate: Dtos.GroupItemTemplate, collection: Dtos.Collection): Observable<Dtos.SetGroupItemTemplateResponse> => {

        let request: Dtos.SetGroupItemTemplate = new Dtos.SetGroupItemTemplate();

        request.groupItemTemplate = groupItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.SetGroupItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
    createGroupItemTemplate: (groupId: number): Observable<Dtos.CreateGroupItemTemplateResponse> => {
        //Create the request.
        let request: Dtos.CreateGroupItemTemplate = new Dtos.CreateGroupItemTemplate();

        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.CreateGroupItemTemplateResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateGroupItemTemplate: (groupItemTemplate: Dtos.GroupItemTemplate, collection: Dtos.Collection): Observable<Dtos.ValidateGroupItemTemplateResponse> => {
    
        let request: Dtos.ValidateGroupItemTemplate = new Dtos.ValidateGroupItemTemplate();

        request.groupItemTemplate = groupItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.ValidateGroupItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
}